module.exports = __webpack_public_path__ + "static/media/morphling.8ef7869e.png";